import {
  SET_KANBAN_STAGES_UI_FLAG,
  SET_KANBAN_STAGES,
  ADD_KANBAN_STAGE,
  EDIT_KANBAN_STAGE,
  DELETE_KANBAN_STAGE,
} from './types';

export const mutations = {
  [SET_KANBAN_STAGES_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [SET_KANBAN_STAGES]($state, data) {
    const records = {};
    data.forEach(stage => {
      records[stage.id] = stage;
    });
    $state.records = records;
  },
  [ADD_KANBAN_STAGE]($state, stage) {
    $state.records = { ...$state.records, [stage.id]: stage };
  },
  [EDIT_KANBAN_STAGE]($state, stage) {
    $state.records = { ...$state.records, [stage.id]: stage };
  },
  [DELETE_KANBAN_STAGE]($state, stageId) {
    const { [stageId]: _, ...rest } = $state.records;
    $state.records = rest;
  },
};
